<template>
  <div>
    <ProgressLabelBar
      :payload="data"
      data-testid="progresslabel-bar"
    />
    <div class="cxm-ProgressLabel-Container">
      <ProgressLabelInfo
        v-for="(item, i) in data"
        :key="i"
        :label="item.label"
        :color="item.color"
        :percentage="item.size"
        :amount="item.amount"
        :hide="item.hide"
        :extra="item.extra"
        :locale="localeFormatted"
        data-testid="progresslabel-info"
      />
    </div>
  </div>
</template>

<script>
import ProgressLabelBar from './ProgressLabelBar.vue';
import ProgressLabelInfo from './ProgressLabelInfo.vue';

export default {
  name: 'ProgressLabel',
  components: {
    ProgressLabelBar,
    ProgressLabelInfo,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    locale: {
      type: String,
      default: 'pt-BR',
    },
  },
  computed: {
    localeFormatted() {
      return this.locale.replace('_', '-');
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-ProgressLabel-Container {
  display: flex;
  gap: var(--track-spacing-xl);
  margin-top: var(--track-spacing-sm);
  margin-bottom: var(--track-spacing-md);
}
</style>
